import { classNames, React } from '@digsup/core-ui';
import { Button } from '@digsup/components-button';
import { Icon } from '@digsup/components-icon';
import PropTypes from 'prop-types';

const cx = classNames;

export const PopoverClose = ({ onClick, className }) => {
  const classes = cx('c-popover__close-button', className);

  return (
    <Button
      size="small"
      onClick={onClick}
      iconOnly
      variant="flat"
      className={classes}
      icon={<Icon size="small" name="x" />}>
      Close
    </Button>
  );
};

PopoverClose.propTypes = {
  className: PropTypes.string,
  /**
   * function will run on click close icon button
   */
  onClick: PropTypes.func.isRequired,
};

PopoverClose.defaultProps = {};
